export const getPerson = client => {
    // try to get primary person first, else just get the first person in the array
    const primaryPerson = client.people.find(p => p.is_primary);
    if (primaryPerson) return primaryPerson;

    return client.people[0];
};
